/* eslint-disable */
export default {
  title: '음성 메시지로 회신',
  customMessage: '사용자 지정 메시지',
  customMessagePlaceholder: '사용자 지정 메시지 입력',
} as const;

// @key: @#@"title"@#@ @source: @#@"Reply with Voice Message"@#@
// @key: @#@"customMessage"@#@ @source: @#@"Custom message"@#@
// @key: @#@"customMessagePlaceholder"@#@ @source: @#@"Type a custom message"@#@
